// src/theme.ts
import { extendTheme } from '@chakra-ui/react'

const pretendard = `'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif`

const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  fonts: {
    heading: pretendard,
    body: pretendard,
    mono: pretendard
  },
  styles: {
    global: {
      'html, body': {
        fontFamily: pretendard,
        fontWeight: '400',
        bg: '#0b0e11',
        color: 'white',
        lineHeight: '1.5',
      },
      '*': {
        fontFamily: pretendard,
        boxSizing: 'border-box',
      },
      '::-webkit-scrollbar': {
        width: '8px',
        height: '8px',
      },
      '::-webkit-scrollbar-track': {
        background: '#15191e',
      },
      '::-webkit-scrollbar-thumb': {
        background: '#2d3748',
        borderRadius: '4px',
      },
      '::-webkit-scrollbar-thumb:hover': {
        background: '#4a5568',
      },
    }
  },
  colors: {
    brand: {
      50: '#FFF9E6',
      100: '#FFF0B3',
      200: '#FFE680',
      300: '#FFD94D',
      400: '#FFCC00',
      500: '#D4AF37', // Primary Royal Gold
      600: '#C5A028',
      700: '#B8860B', // Dark Goldenrod
      800: '#9A7209',
      900: '#7D5A07',
    },
    dark: {
      bg: '#0b0e11',     // Main Background
      card: '#15191e',   // Card Background
      border: '#2d3748', // Border Color
      hover: '#1a202c',  // Hover State
    },
    accent: {
      pink: '#ec4899',
      orange: '#f97316',
      green: '#22c55e',
      red: '#ef4444',
    }
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: '600',
        borderRadius: '8px',
      },
      variants: {
        solid: (props: any) => ({
          bg: props.colorScheme === 'blue' ? 'brand.500' : undefined,
          color: props.colorScheme === 'blue' ? '#1a1a1a' : 'white',
          _hover: {
            bg: props.colorScheme === 'blue' ? 'brand.600' : undefined,
          },
        }),
        outline: {
          borderColor: 'dark.border',
          color: 'gray.300',
          _hover: {
            bg: 'dark.hover',
          },
        },
      },
    },
    Card: {
      baseStyle: {
        container: {
          bg: 'dark.card',
          borderRadius: '12px',
          border: '1px solid',
          borderColor: 'dark.border',
          p: 6,
        },
      },
    },
    Input: {
      variants: {
        filled: {
          field: {
            bg: '#1a202c',
            border: '1px solid',
            borderColor: 'transparent',
            _focus: {
              bg: '#1a202c',
              borderColor: 'brand.500',
            },
            _hover: {
              bg: '#2d3748',
            },
          },
        },
      },
      defaultProps: {
        variant: 'filled',
      },
    },
    Menu: {
      baseStyle: {
        list: {
          bg: 'dark.card',
          borderColor: 'dark.border',
        },
        item: {
          bg: 'dark.card',
          _hover: {
            bg: 'dark.hover',
          },
          _focus: {
            bg: 'dark.hover',
          },
        },
      },
    },
    Modal: {
      baseStyle: {
        dialog: {
          bg: 'dark.card',
        },
      },
    },
  },
})

export default theme
